<template>
    <div
        v-if="(mode !== 'atBat' && batterPanelState === true) && (currentAngle === 'batterLeft' || currentAngle === 'batterRight')"
        class="batterController"
    >
        <div
            v-if="batterInputState === 0"
            class="batterDefaultWrapper"
        >
            <div
                class="close"
                @click="closeBatterPanel()"
            >
                ×
            </div>
            <div class="batterPosition">
                <table>
                    <tr>
                        <td>打者位置</td>
                        <td @click="changeBatterInputState(1)">
                            <span>{{ formatBatParamsz(currentParamsz) }}cm {{
                                formatBatParamsx(currentParamsx)
                            }}cm</span>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="boxWrapper">
                <div class="batterBox">
                    <svg
                        width="48"
                        height="72"
                    >
                        <path
                            d="M46,2V70H2V2H46m2-2H0V72H48V0Z"
                            transform="translate(0 0)"
                        />
                        <rect
                            width="48"
                            height="72"
                            fill="none"
                        />
                        <image
                            xlink:href="@/assets/footprint_leftside.svg"
                            :x="xScale(slideBatx)"
                            :y="yScale(slideBatz)"
                            height="24px"
                            width="11px"
                        />
                    </svg>
                    <svg
                        width="29"
                        height="72"
                    >
                        <path
                            d="M14.5,45.88,5,36.42V26.54H24v9.88ZM7,35.58l7.5,7.47L22,35.58v-7H7Z"
                            transform="translate(0)"
                        />
                        <rect
                            width="29"
                            height="72"
                            fill="none"
                        />
                    </svg>
                    <svg
                        width="48"
                        height="72"
                    >
                        <path
                            d="M46,2V70H2V2H46m2-2H0V72H48V0Z"
                            transform="translate(0 0)"
                        />
                        <rect
                            width="48"
                            height="72"
                            fill="none"
                        />
                        <image
                            xlink:href="@/assets/footprint_rightside.svg"
                            :x="xScale2(slideBatx)"
                            :y="yScale(slideBatz)"
                            height="24px"
                            width="11px"
                        />
                    </svg>
                </div>
                <div class="boxController">
                    <table>
                        <tr>
                            <td
                                v-if="currentParamsz >= 10"
                                class="disabledBtn"
                            >
                                後
                            </td>
                            <td
                                v-else
                                @click="changeWard('backward')"
                            >
                                後
                            </td>
                            <td
                                v-if="currentParamsz <= -100"
                                class="disabledBtn"
                            >
                                前
                            </td>
                            <td
                                v-else
                                @click="changeWard('forward')"
                            >
                                前
                            </td>
                        </tr>
                    </table>
                    <table>
                        <tr v-if="currentAngle === 'batterLeft'">
                            <td
                                v-if="currentParamsx <= -70"
                                class="disabledBtn"
                            >
                                左
                            </td>
                            <td
                                v-else
                                @click="changeWard('leftward')"
                            >
                                左
                            </td>
                            <td
                                v-if="currentParamsx >= 10"
                                class="disabledBtn"
                            >
                                右
                            </td>
                            <td
                                v-else
                                @click="changeWard('rightward')"
                            >
                                右
                            </td>
                        </tr>
                        <tr v-else-if="currentAngle === 'batterRight'">
                            <td
                                v-if="currentParamsx <= -30"
                                class="disabledBtn"
                            >
                                左
                            </td>
                            <td
                                v-else
                                @click="changeWard('leftward')"
                            >
                                左
                            </td>
                            <td
                                v-if="currentParamsx >= 40"
                                class="disabledBtn"
                            >
                                右
                            </td>
                            <td
                                v-else
                                @click="changeWard('rightward')"
                            >
                                右
                            </td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td
                                colspan="2"
                                @click="resetSlideParams()"
                            >
                                リセット
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="batterPoint">
                <table>
                    <tr>
                        <td>打者目線</td>
                        <td @click="changeBatterInputState(2)">
                            {{ slideParamsy1 }}cm
                        </td>
                    </tr>
                </table>
            </div>
            <div class="pointBar">
                <input
                    v-model="slideParamsy1"
                    type="range"
                    :min="currentBatterPointSet.slideBatPointMin"
                    :max="currentBatterPointSet.slideBatPointMax"
                    step="1"
                    value=""
                >
                <table class="rangeLabel">
                    <tr>
                        <td>160</td>
                        <td>180</td>
                        <td>200</td>
                    </tr>
                </table>
            </div>
        </div>
        <div
            v-else-if="batterInputState === 1"
            class="batterInputWrapper"
        >
            <p>打者位置設定</p>
            <table class="batterInputInner">
                <tr>
                    <td>
                        <input
                            type="radio"
                            name="beforeAfter"
                            value=""
                            :checked="beforeAfterFlg"
                        >
                        <svg
                            width="55"
                            height="20"
                            @click="toggleBeforeAfterFlg(true)"
                        >
                            <text
                                x="0"
                                y="13"
                                font-size="11"
                                fill="#ffffff"
                            >後</text>
                            <circle
                                cx="30"
                                cy="10"
                                r="10"
                                fill="#222222"
                                stroke-width="0"
                                fill-opacity="0.75"
                            />
                            <circle
                                v-if="beforeAfterFlg"
                                cx="30"
                                cy="10"
                                r="5"
                                fill="#ffffff"
                                stroke-width="0"
                            />
                        </svg>
                    </td>
                    <td>
                        <input
                            type="radio"
                            name="beforeAfter"
                            value=""
                            :checked="!beforeAfterFlg"
                        >
                        <svg
                            width="55"
                            height="20"
                            @click="toggleBeforeAfterFlg(false)"
                        >
                            <text
                                x="0"
                                y="13"
                                font-size="11"
                                fill="#ffffff"
                            >前</text>
                            <circle
                                cx="30"
                                cy="10"
                                r="10"
                                fill="#222222"
                                stroke-width="0"
                                fill-opacity="0.75"
                            />
                            <circle
                                v-if="!beforeAfterFlg"
                                cx="30"
                                cy="10"
                                r="5"
                                fill="#ffffff"
                                stroke-width="0"
                            />
                        </svg>
                    </td>
                    <td>
                        <input
                            v-model.number="inputParamsz"
                            type="number"
                            min="0"
                            max="100"
                            value=""
                            @input="validBatterParamsz($event, inputParamsz)"
                            @blur="blurAfter()"
                        ><span
                            class="unit"
                        > cm</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <input
                            type="radio"
                            name="leftRight"
                            value=""
                            :checked="leftRightFlg"
                        >
                        <svg
                            width="55"
                            height="20"
                            @click="toggleLeftRightFlg(true)"
                        >
                            <text
                                x="0"
                                y="13"
                                font-size="11"
                                fill="#ffffff"
                            >左</text>
                            <circle
                                cx="30"
                                cy="10"
                                r="10"
                                fill="#222222"
                                stroke-width="0"
                                fill-opacity="0.75"
                            />
                            <circle
                                v-if="leftRightFlg"
                                cx="30"
                                cy="10"
                                r="5"
                                fill="#ffffff"
                                stroke-width="0"
                            />
                        </svg>
                    </td>
                    <td>
                        <input
                            type="radio"
                            name="leftRight"
                            value=""
                            :checked="!leftRightFlg"
                        >
                        <svg
                            width="20"
                            height="20"
                            @click="toggleLeftRightFlg(false)"
                        >
                            <text
                                x="0"
                                y="13"
                                font-size="11"
                                fill="#ffffff"
                            >右</text>
                            <circle
                                cx="30"
                                cy="10"
                                r="10"
                                fill="#222222"
                                stroke-width="0"
                                fill-opacity="0.75"
                            />
                            <circle
                                v-if="!leftRightFlg"
                                cx="30"
                                cy="10"
                                r="5"
                                fill="#ffffff"
                                stroke-width="0"
                            />
                        </svg>
                    </td>
                    <td>
                        <input
                            v-model.number="inputParamsx"
                            type="number"
                            value="0"
                            @input="validBatterParamsx($event, inputParamsx)"
                            @blur="blurAfter()"
                        ><span
                            class="unit"
                        > cm</span>
                    </td>
                </tr>
            </table>
            <table class="batterSubmitButton">
                <tr>
                    <td @click="changeBatterInputState(0)">
                        <span>キャンセル</span>
                    </td>
                    <td>
                        <span
                            v-if="batterPositionIsValid"
                            class="disabledBtn"
                        >設定する</span>
                        <span
                            v-else
                            @click="submitBatterPosition()"
                        >設定する</span>
                    </td>
                    <td><span @click="resetBatterPosition()">リセット</span></td>
                </tr>
            </table>
        </div>
        <div
            v-else-if="batterInputState === 2"
            class="batterInputWrapper point"
        >
            <p>打者目線設定</p>
            <table class="batterInputInner">
                <tr>
                    <td>
                        <input
                            v-model.number="inputParamsy"
                            type="number"
                            value=""
                            @input="validBatterParamsy($event, inputParamsy)"
                            @blur="blurAfter()"
                        ><span
                            class="unit"
                        > cm</span>
                    </td>
                </tr>
            </table>
            <table class="batterSubmitButton">
                <tr>
                    <td @click="changeBatterInputState(0)">
                        <span>キャンセル</span>
                    </td>
                    <td>
                        <span
                            v-if="batterPointIsValid"
                            class="disabledBtn"
                        >設定する</span>
                        <span
                            v-else
                            @click="submitBatterPoint()"
                        >設定する</span>
                    </td>
                    <td><span @click="resetBatterPoint()">リセット</span></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import Common3dBatterController from '@/components_common/3d/BatterController.vue'

export default {
    mixins: [Common3dBatterController],
}
</script>

<style scoped>
/* 打者位置・打者目線 */
.batterController {
    position: absolute;
    color: #fff;
    width: 250px;
    background: rgba(51, 51, 51, 0.95);
    padding-bottom: 15px;
    margin-top: 10px;
    top: 301px;
    right: 84px;
}

.batterPosition {
    padding: 10px 15px 0;
    font-size: 13px;
    line-height: 13px;
}

.batterPosition tr td {
    width: 60px;
    height: 20px;
    font-size: 13px;
    text-align: left;
    vertical-align: middle;
    cursor: pointer;
}

.batterPosition tr td:nth-child(2) {
    width: 110px;
    height: 20px;
    background-color: rgba(34, 34, 34, 0.75);
    font-size: 11px;
    text-align: center;
}

.boxWrapper {
    width: 220px;
    padding-top: 10px;
    margin: 0 auto;
}

.batterBox {
    width: 125px;
    height: 118px;
    padding-top: 23px;
    display: inline-block;
    overflow: hidden;
}

.batterBox svg {
    width: 48px;
    height: 72px;
    float: left;
}

.batterBox svg:nth-child(2) {
    width: 29px;
    height: 72px;
}

.batterBox svg path {
    fill: #ffffff;
    stroke-width: 0;
    stroke: none;
}

.boxController {
    width: 82px;
    height: 118px;
    display: inline-block;
    margin-left: 10px;
    padding-top: 1px;
}

.boxController table {
    width: 82px;
    height: 16px;
    margin-bottom: 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}

.boxController table:nth-child(3) {
    margin-bottom: 0;
}

.boxController table tr td {
    width: 50%;
    height: 32px;
    border: 1px solid #ffffff;
    font-size: 1rem;
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}

.boxController table tr td:nth-child(2) {
    border-left: 0;
}

.batterPoint {
    padding: 15px 15px 0;
    font-size: 13px;
    line-height: 13px;
}

.batterPoint tr td {
    width: 60px;
    height: 20px;
    font-size: 13px;
    text-align: left;
    vertical-align: middle;
}

.batterPoint tr td:nth-child(2) {
    width: 110px;
    height: 20px;
    background-color: rgba(34, 34, 34, 0.75);
    font-size: 11px;
    text-align: center;
}

/* 打者位置設定パネル */
.batterInputWrapper {
    width: 250px;
    padding: 10px 15px 0;
    font-size: 13px;
    height: 204px;
}

.batterInputWrapper p {
    padding-top: 2px;
    font-size: 13px;
    line-height: 13px;
}

.batterInputWrapper table.batterInputInner {
    width: 220px;
    margin: 34.5px auto;
}

.batterInputWrapper table.batterInputInner tr {
    width: 100%;
    height: 24px;
    box-sizing: border-box;
}

.batterInputWrapper table.batterInputInner tr td {
    width: 110px;
    height: 24px;
    box-sizing: border-box;
    padding-bottom: 30px;
}

.batterInputWrapper table.batterInputInner tr td:nth-child(1),
.batterInputWrapper table.batterInputInner tr td:nth-child(2) {
    width: 55px;
}

.batterInputWrapper table.batterInputInner tr td input[type="number"] {
    -webkit-appearance: none;
}

.batterInputWrapper table.batterInputInner tr td input[type="radio"] {
    display: none;
}

.batterInputWrapper table.batterInputInner tr td input[type="number"] {
    width: 80px;
    height: 24px;
    outline: none;
    border: none;
    background: rgba(34, 34, 34, 0.75);
    color: #ffffff;
    text-align: center;
    line-height: 13px;
    float: left;
    font-size: 11px;
}

.batterInputWrapper table.batterInputInner tr td .unit {
    padding-top: 4px;
    padding-left: 10px;
    float: left;
}

.batterInputWrapper table.batterInputInner tr:nth-child(2) td {
    padding-bottom: 0;
}

.batterInputWrapper table.batterInputInner tr td svg {
    width: 55px;
    height: 24px;
    box-sizing: border-box;
}

.batterInputWrapper table.batterSubmitButton {
    width: 220px;
    margin: 0 auto 10px;
}

.batterInputWrapper table.batterSubmitButton tr td {
    width: 66px;
    text-align: center;
    padding: 0 5px;
}

.batterInputWrapper table.batterSubmitButton tr td:nth-child(1) {
    padding-left: 0;
}

.batterInputWrapper table.batterSubmitButton tr td:nth-child(3) {
    padding-right: 0;
}

.batterInputWrapper table.batterSubmitButton tr td span {
    width: 66px;
    height: 24px;
    display: inline-block;
    font-size: 11px;
    padding-top: 5px;
    border: 1px solid #ffffff;
    box-sizing: border-box;
}

/* 打者目線設定パネル */
.batterInputWrapper.point table.batterInputInner {
    margin: 62px auto;
}

.batterInputWrapper.point table.batterInputInner tr td {
    box-sizing: border-box;
    padding-bottom: 0;
}

.batterInputWrapper.point table.batterInputInner tr td input[type="number"] {
    margin-left: 54px;
}

/* 投手位置・投手目線 */
.pitcherController {
    position: relative;
    color: #fff;
    width: 250px;
    background: rgba(51, 51, 51, 0.95);
    padding-bottom: 15px;
    margin-top: 10px;
}

.pitcherPosition {
    padding: 10px 15px 0;
    font-size: 13px;
    line-height: 13px;
}

.pitcherPosition tr td {
    width: 60px;
    height: 20px;
    font-size: 13px;
    text-align: left;
    vertical-align: middle;
}

.pitcherPosition tr td:nth-child(2) {
    width: 110px;
    height: 20px;
    background-color: rgba(34, 34, 34, 0.75);
    font-size: 11px;
    text-align: center;
}

.positionBar {
    padding: 15px 0 10px;
}

.pitcherPoint {
    padding: 15px 15px 0;
    font-size: 13px;
    line-height: 13px;
}

.pitcherPoint tr td {
    width: 60px;
    height: 20px;
    font-size: 13px;
    text-align: left;
    vertical-align: middle;
}

.pitcherPoint tr td:nth-child(2) {
    width: 110px;
    height: 20px;
    background-color: rgba(34, 34, 34, 0.75);
    font-size: 11px;
    text-align: center;
}

.pointBar {
    padding: 15px 0 0;
}

/* 投手位置設定パネル */
.pitcherInputWrapper {
    width: 250px;
    padding: 10px 15px 0;
    font-size: 13px;
    height: 204px;
}

.pitcherInputWrapper p {
    padding-top: 2px;
    font-size: 13px;
    line-height: 13px;
}

.pitcherInputWrapper table.pitcherInputInner {
    width: 220px;
    margin: 62px auto;
}

.pitcherInputWrapper table.pitcherInputInner tr {
    width: 100%;
    height: 24px;
    box-sizing: border-box;
}

.pitcherInputWrapper table.pitcherInputInner tr td {
    width: 110px;
    height: 24px;
    box-sizing: border-box;
    padding-bottom: 0;
}

.pitcherInputWrapper table.pitcherInputInner tr td:nth-child(1),
.pitcherInputWrapper table.pitcherInputInner tr td:nth-child(2) {
    width: 55px;
}

.pitcherInputWrapper table.pitcherInputInner tr td input[type="number"] {
    -webkit-appearance: none;
}

.pitcherInputWrapper table.pitcherInputInner tr td input[type="radio"] {
    display: none;
}

.pitcherInputWrapper table.pitcherInputInner tr td input[type="number"] {
    width: 80px;
    height: 24px;
    outline: none;
    border: none;
    background: rgba(34, 34, 34, 0.75);
    color: #ffffff;
    text-align: center;
    line-height: 13px;
    float: left;
    font-size: 11px;
}

.pitcherInputWrapper table.pitcherInputInner tr td .unit {
    padding-top: 4px;
    padding-left: 10px;
    float: left;
}

.pitcherInputWrapper table.pitcherInputInner tr:nth-child(2) td {
    padding-bottom: 0;
}

.pitcherInputWrapper table.pitcherInputInner tr td svg {
    width: 55px;
    height: 24px;
    box-sizing: border-box;
}

.pitcherInputWrapper table.pitcherSubmitButton {
    width: 220px;
    margin: 0 auto 10px;
}

.pitcherInputWrapper table.pitcherSubmitButton tr td {
    width: 66px;
    text-align: center;
    padding: 0 5px;
}

.pitcherInputWrapper table.pitcherSubmitButton tr td:nth-child(1) {
    padding-left: 0;
}

.pitcherInputWrapper table.pitcherSubmitButton tr td:nth-child(3) {
    padding-right: 0;
}

.pitcherInputWrapper table.pitcherSubmitButton tr td span {
    width: 66px;
    height: 24px;
    display: inline-block;
    font-size: 11px;
    padding-top: 5px;
    border: 1px solid #ffffff;
    box-sizing: border-box;
}

/* 投手目線設定パネル */
.pitcherInputWrapper.point table.pitcherInputInner {
    margin: 62px auto;
}

.pitcherInputWrapper.point table.pitcherInputInner tr td {
    box-sizing: border-box;
    padding-bottom: 0;
}

.pitcherInputWrapper.point table.pitcherInputInner tr td input[type="number"] {
    margin-left: 54px;
}

/* slider */
[type="range"] {
    display: block;
    position: relative;
    width: 220px;
    margin: 0 auto;
    height: 1px;
    background-color: rgba(255, 255, 255, 1);
    z-index: 1;
}

[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    position: relative;
    z-index: 15;
    width: 12px;
    height: 12px;
    background-color: rgba(255, 255, 255, 1);
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

[type="range"]:focus,
[type="range"]:focus::-webkit-slider-thumb,
[type="range"]:active,
[type="range"]:active::-webkit-slider-thumb {
    outline: none;
}

[type="range"]:active::-webkit-slider-thumb {
    background-color: rgba(255, 20, 147, 1.0);
}

/* slider label */
.rangeLabel {
    width: 220px;
    margin: 10px auto 0;
}

.rangeLabel tr td:nth-child(1) {
    text-align: left;
}

.rangeLabel tr td:nth-child(2) {
    text-align: center;
}

.rangeLabel tr td:nth-child(3) {
    text-align: right;
}

.close {
    width: 25px;
    height: 25px;
    position: absolute;
    color: #fff;
    line-height: 25px;
    font-size: 20px;
    top: 8px;
    right: 10px;
    cursor: pointer;
}

.disabledBtn {
    opacity: 0.65;
}

.disable {
    opacity: 0.5;
}
</style>
